import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseViewComponent, EmptyStateGraphic, EmptyStateSize } from '@sb/library/base';

@Component({
    selector: 'lib-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent extends BaseViewComponent implements OnInit {
    readonly searchNoResultsFoundGraphic: string = EmptyStateGraphic.NoResultsFound;

    @Input() searchActive: boolean = false;
    @Input() size: EmptyStateSize = EmptyStateSize.Medium;
    @Input() qaTag: string = '';
    @Input() emptyStateGraphic: EmptyStateGraphic = EmptyStateGraphic.HomeHeader;



    @Output() clearClicked: EventEmitter<void> = new EventEmitter();


    ClearSearchClicked(): void {
        this.clearClicked.emit();
    }



}
